/**
 * name: @storyblok/js
 * (c) 2025
 * description: SDK to integrate Storyblok into your project using JavaScript.
 * author: undefined
 */
const lt = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, ht = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;
function O(s) {
  switch (s) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function G(s) {
  if (s >= 8192 && s <= 8202)
    return !0;
  switch (s) {
    case 9:
    // \t
    case 10:
    // \n
    case 11:
    // \v
    case 12:
    // \f
    case 13:
    // \r
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function q(s) {
  return lt.test(s) || ht.test(s);
}
function J(s) {
  switch (s) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function x(s, t, e) {
  this.type = s, this.tag = t, this.attrs = null, this.map = null, this.nesting = e, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
x.prototype.attrIndex = function(t) {
  if (!this.attrs)
    return -1;
  const e = this.attrs;
  for (let r = 0, u = e.length; r < u; r++)
    if (e[r][0] === t)
      return r;
  return -1;
};
x.prototype.attrPush = function(t) {
  this.attrs ? this.attrs.push(t) : this.attrs = [t];
};
x.prototype.attrSet = function(t, e) {
  const r = this.attrIndex(t), u = [t, e];
  r < 0 ? this.attrPush(u) : this.attrs[r] = u;
};
x.prototype.attrGet = function(t) {
  const e = this.attrIndex(t);
  let r = null;
  return e >= 0 && (r = this.attrs[e][1]), r;
};
x.prototype.attrJoin = function(t, e) {
  const r = this.attrIndex(t);
  r < 0 ? this.attrPush([t, e]) : this.attrs[r][1] = this.attrs[r][1] + " " + e;
};
function Dt(s, t, e) {
  this.src = s, this.env = e, this.tokens = [], this.inlineMode = !1, this.md = t;
}
Dt.prototype.Token = x;
function w(s, t, e, r) {
  this.src = s, this.md = t, this.env = e, this.tokens = r, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
  const u = this.src;
  for (let i = 0, a = 0, o = 0, n = 0, c = u.length, h = !1; a < c; a++) {
    const D = u.charCodeAt(a);
    if (!h)
      if (O(D)) {
        o++, D === 9 ? n += 4 - n % 4 : n++;
        continue;
      } else
        h = !0;
    (D === 10 || a === c - 1) && (D !== 10 && a++, this.bMarks.push(i), this.eMarks.push(a), this.tShift.push(o), this.sCount.push(n), this.bsCount.push(0), h = !1, o = 0, n = 0, i = a + 1);
  }
  this.bMarks.push(u.length), this.eMarks.push(u.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
w.prototype.push = function(s, t, e) {
  const r = new x(s, t, e);
  return r.block = !0, e < 0 && this.level--, r.level = this.level, e > 0 && this.level++, this.tokens.push(r), r;
};
w.prototype.isEmpty = function(t) {
  return this.bMarks[t] + this.tShift[t] >= this.eMarks[t];
};
w.prototype.skipEmptyLines = function(t) {
  for (let e = this.lineMax; t < e && !(this.bMarks[t] + this.tShift[t] < this.eMarks[t]); t++)
    ;
  return t;
};
w.prototype.skipSpaces = function(t) {
  for (let e = this.src.length; t < e; t++) {
    const r = this.src.charCodeAt(t);
    if (!O(r))
      break;
  }
  return t;
};
w.prototype.skipSpacesBack = function(t, e) {
  if (t <= e)
    return t;
  for (; t > e; )
    if (!O(this.src.charCodeAt(--t)))
      return t + 1;
  return t;
};
w.prototype.skipChars = function(t, e) {
  for (let r = this.src.length; t < r && this.src.charCodeAt(t) === e; t++)
    ;
  return t;
};
w.prototype.skipCharsBack = function(t, e, r) {
  if (t <= r)
    return t;
  for (; t > r; )
    if (e !== this.src.charCodeAt(--t))
      return t + 1;
  return t;
};
w.prototype.getLines = function(t, e, r, u) {
  if (t >= e)
    return "";
  const i = new Array(e - t);
  for (let a = 0, o = t; o < e; o++, a++) {
    let n = 0;
    const c = this.bMarks[o];
    let h = c, D;
    for (o + 1 < e || u ? D = this.eMarks[o] + 1 : D = this.eMarks[o]; h < D && n < r; ) {
      const A = this.src.charCodeAt(h);
      if (O(A))
        A === 9 ? n += 4 - (n + this.bsCount[o]) % 4 : n++;
      else if (h - c < this.tShift[o])
        n++;
      else
        break;
      h++;
    }
    n > r ? i[a] = new Array(n - r + 1).join(" ") + this.src.slice(h, D) : i[a] = this.src.slice(h, D);
  }
  return i.join("");
};
w.prototype.Token = x;
const dt = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Ft = "[a-zA-Z_:][a-zA-Z0-9:._-]*", ft = "[^\"'=<>`\\x00-\\x20]+", pt = "'[^']*'", Et = '"[^"]*"', At = "(?:" + ft + "|" + pt + "|" + Et + ")", Ct = "(?:\\s+" + Ft + "(?:\\s*=\\s*" + At + ")?)", gt = "<[A-Za-z][A-Za-z0-9\\-]*" + Ct + "*\\s*\\/?>", mt = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", yt = new RegExp("^(?:" + gt + "|" + mt + ")");
new RegExp("^</?(" + dt.join("|") + ")(?=(\\s|/?>|$))", "i"), new RegExp(yt.source + "\\s*$");
function P(s, t, e, r) {
  this.src = s, this.env = e, this.md = t, this.tokens = r, this.tokens_meta = Array(r.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
P.prototype.pushPending = function() {
  const s = new x("text", "", 0);
  return s.content = this.pending, s.level = this.pendingLevel, this.tokens.push(s), this.pending = "", s;
};
P.prototype.push = function(s, t, e) {
  this.pending && this.pushPending();
  const r = new x(s, t, e);
  let u = null;
  return e < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), r.level = this.level, e > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], u = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(r), this.tokens_meta.push(u), r;
};
P.prototype.scanDelims = function(s, t) {
  const e = this.posMax, r = this.src.charCodeAt(s), u = s > 0 ? this.src.charCodeAt(s - 1) : 32;
  let i = s;
  for (; i < e && this.src.charCodeAt(i) === r; )
    i++;
  const a = i - s, o = i < e ? this.src.charCodeAt(i) : 32, n = J(u) || q(String.fromCharCode(u)), c = J(o) || q(String.fromCharCode(o)), h = G(u), D = G(o), A = !D && (!c || h || n), m = !h && (!n || D || c);
  return { can_open: A && (t || !m || n), can_close: m && (t || !A || c), length: a };
};
P.prototype.Token = x;
const Q = [];
for (let s = 0; s < 256; s++)
  Q.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(s) {
  Q[s.charCodeAt(0)] = 1;
});
let b = /* @__PURE__ */ function(s) {
  return s.DOCUMENT = "doc", s.HEADING = "heading", s.PARAGRAPH = "paragraph", s.QUOTE = "blockquote", s.OL_LIST = "ordered_list", s.UL_LIST = "bullet_list", s.LIST_ITEM = "list_item", s.CODE_BLOCK = "code_block", s.HR = "horizontal_rule", s.BR = "hard_break", s.IMAGE = "image", s.EMOJI = "emoji", s.COMPONENT = "blok", s.TABLE = "table", s.TABLE_ROW = "tableRow", s.TABLE_CELL = "tableCell", s.TABLE_HEADER = "tableHeader", s;
}({}), k = /* @__PURE__ */ function(s) {
  return s.BOLD = "bold", s.STRONG = "strong", s.STRIKE = "strike", s.UNDERLINE = "underline", s.ITALIC = "italic", s.CODE = "code", s.LINK = "link", s.ANCHOR = "anchor", s.STYLED = "styled", s.SUPERSCRIPT = "superscript", s.SUBSCRIPT = "subscript", s.TEXT_STYLE = "textStyle", s.HIGHLIGHT = "highlight", s;
}({}), bt = /* @__PURE__ */ function(s) {
  return s.TEXT = "text", s;
}({}), I = /* @__PURE__ */ function(s) {
  return s.URL = "url", s.STORY = "story", s.ASSET = "asset", s.EMAIL = "email", s;
}({});
function vt(s, t) {
  if (!t) return {
    src: s,
    attrs: {}
  };
  let e = 0, r = 0;
  const u = {}, i = [];
  function a(n, c, h, D, A) {
    typeof n != "number" || n <= c || n >= h ? console.warn(`[StoryblokRichText] - ${D.charAt(0).toUpperCase() + D.slice(1)} value must be a number between ${c} and ${h} (inclusive)`) : A.push(`${D}(${n})`);
  }
  if (typeof t == "object") {
    if (typeof t.width == "number" && t.width > 0 ? (u.width = t.width, e = t.width) : console.warn("[StoryblokRichText] - Width value must be a number greater than 0"), t.height && typeof t.height == "number" && t.height > 0 ? (u.height = t.height, r = t.height) : console.warn("[StoryblokRichText] - Height value must be a number greater than 0"), t.loading && ["lazy", "eager"].includes(t.loading) && (u.loading = t.loading), t.class && (u.class = t.class), t.filters) {
      const { filters: n } = t || {}, { blur: c, brightness: h, fill: D, format: A, grayscale: m, quality: _, rotate: R } = n || {};
      c && a(c, 0, 100, "blur", i), _ && a(_, 0, 100, "quality", i), h && a(h, 0, 100, "brightness", i), D && i.push(`fill(${D})`), m && i.push("grayscale()"), R && [
        0,
        90,
        180,
        270
      ].includes(t.filters.rotate || 0) && i.push(`rotate(${R})`), A && [
        "webp",
        "png",
        "jpeg"
      ].includes(A) && i.push(`format(${A})`);
    }
    t.srcset && (u.srcset = t.srcset.map((n) => {
      if (typeof n == "number") return `${s}/m/${n}x0/${i.length > 0 ? `filters:${i.join(":")}` : ""} ${n}w`;
      if (Array.isArray(n) && n.length === 2) {
        const [c, h] = n;
        return `${s}/m/${c}x${h}/${i.length > 0 ? `filters:${i.join(":")}` : ""} ${c}w`;
      } else {
        console.warn("[StoryblokRichText] - srcset entry must be a number or a tuple of two numbers");
        return;
      }
    }).join(", ")), t.sizes && (u.sizes = t.sizes.join(", "));
  }
  let o = `${s}/m/`;
  return e > 0 && r > 0 && (o = `${o}${e}x${r}/`), i.length > 0 && (o = `${o}filters:${i.join(":")}`), {
    src: o,
    attrs: u
  };
}
const kt = [
  "area",
  "base",
  "br",
  "col",
  "embed",
  "hr",
  "img",
  "input",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], xt = (s = {}) => Object.keys(s).map((t) => `${t}="${s[t]}"`).join(" "), wt = (s = {}) => Object.keys(s).map((t) => `${t}: ${s[t]}`).join("; ");
function Bt(s) {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
const L = (s) => Object.fromEntries(Object.entries(s).filter(([t, e]) => e !== void 0));
function V(s, t = {}, e) {
  const r = xt(t), u = r ? `${s} ${r}` : s, i = Array.isArray(e) ? e.join("") : e || "";
  if (s) {
    if (kt.includes(s)) return `<${u}>`;
  } else return i;
  return `<${u}>${i}</${s}>`;
}
function _t(s = {}) {
  const t = /* @__PURE__ */ new Map(), { renderFn: e = V, textFn: r = Bt, resolvers: u = {}, optimizeImages: i = !1, keyedResolvers: a = !1 } = s, o = e !== V, n = (l) => (F, d) => {
    const f = F.attrs || {};
    return d.render(l, f, F.children || null);
  }, c = (l, F) => {
    const { src: d, alt: f, title: E, srcset: C, sizes: g } = l.attrs || {};
    let y = d, v = {};
    if (i) {
      const { src: at, attrs: ct } = vt(d, i);
      y = at, v = ct;
    }
    const ot = {
      src: y,
      alt: f,
      title: E,
      srcset: C,
      sizes: g,
      ...v
    };
    return F.render("img", L(ot));
  }, h = (l, F) => {
    const { level: d, ...f } = l.attrs || {};
    return F.render(`h${d}`, f, l.children);
  }, D = (l, F) => {
    var f, E, C, g;
    const d = F.render("img", {
      src: (f = l.attrs) == null ? void 0 : f.fallbackImage,
      alt: (E = l.attrs) == null ? void 0 : E.alt,
      style: "width: 1.25em; height: 1.25em; vertical-align: text-top",
      draggable: "false",
      loading: "lazy"
    });
    return F.render("span", {
      "data-type": "emoji",
      "data-name": (C = l.attrs) == null ? void 0 : C.name,
      "data-emoji": (g = l.attrs) == null ? void 0 : g.emoji
    }, d);
  }, A = (l, F) => F.render("pre", l.attrs || {}, F.render("code", {}, l.children || "")), m = (l, F = !1) => ({ text: d, attrs: f }, E) => {
    const { class: C, id: g, ...y } = f || {}, v = F ? {
      class: C,
      id: g,
      style: wt(y) || void 0
    } : f || {};
    return E.render(l, L(v), d);
  }, _ = (l) => $(l), R = (l) => {
    const { marks: F, ...d } = l;
    if ("text" in l) {
      if (F) return F.reduce((E, C) => _({
        ...C,
        text: E
      }), _({
        ...d,
        children: d.children
      }));
      const f = l.attrs || {};
      if (a) {
        const E = t.get("txt") || 0;
        t.set("txt", E + 1), f.key = `txt-${E}`;
      }
      return r(d.text, f);
    }
    return "";
  }, M = (l, F) => {
    const { linktype: d, href: f, anchor: E, ...C } = l.attrs || {};
    let g = "";
    switch (d) {
      case I.ASSET:
      case I.URL:
        g = f;
        break;
      case I.EMAIL:
        g = `mailto:${f}`;
        break;
      case I.STORY:
        g = f, E && (g = `${g}#${E}`);
        break;
      default:
        g = f;
        break;
    }
    const y = { ...C };
    return g && (y.href = g), F.render("a", y, l.text);
  }, et = (l, F) => {
    var d, f;
    return console.warn("[StoryblokRichtText] - BLOK resolver is not available for vanilla usage"), F.render("span", {
      blok: (d = l == null ? void 0 : l.attrs) == null ? void 0 : d.body[0],
      id: (f = l.attrs) == null ? void 0 : f.id,
      style: "display: none"
    });
  }, st = (l, F) => {
    const d = {}, f = F.render("tbody", {}, l.children);
    return F.render("table", d, f);
  }, rt = (l, F) => {
    const d = {};
    return F.render("tr", d, l.children);
  }, ut = (l, F) => {
    const { colspan: d, rowspan: f, colwidth: E, backgroundColor: C, ...g } = l.attrs || {}, y = { ...g };
    d > 1 && (y.colspan = d), f > 1 && (y.rowspan = f);
    const v = [];
    return E && v.push(`width: ${E}px;`), C && v.push(`background-color: ${C};`), v.length > 0 && (y.style = v.join(" ")), F.render("td", L(y), l.children);
  }, it = (l, F) => {
    const { colspan: d, rowspan: f, colwidth: E, backgroundColor: C, ...g } = l.attrs || {}, y = { ...g };
    d > 1 && (y.colspan = d), f > 1 && (y.rowspan = f);
    const v = [];
    return E && v.push(`width: ${E}px;`), C && v.push(`background-color: ${C};`), v.length > 0 && (y.style = v.join(" ")), F.render("th", L(y), l.children);
  }, U = /* @__PURE__ */ new Map([
    [b.DOCUMENT, n("")],
    [b.HEADING, h],
    [b.PARAGRAPH, n("p")],
    [b.UL_LIST, n("ul")],
    [b.OL_LIST, n("ol")],
    [b.LIST_ITEM, n("li")],
    [b.IMAGE, c],
    [b.EMOJI, D],
    [b.CODE_BLOCK, A],
    [b.HR, n("hr")],
    [b.BR, n("br")],
    [b.QUOTE, n("blockquote")],
    [b.COMPONENT, et],
    [bt.TEXT, R],
    [k.LINK, M],
    [k.ANCHOR, M],
    [k.STYLED, m("span", !0)],
    [k.BOLD, m("strong")],
    [k.TEXT_STYLE, m("span", !0)],
    [k.ITALIC, m("em")],
    [k.UNDERLINE, m("u")],
    [k.STRIKE, m("s")],
    [k.CODE, m("code")],
    [k.SUPERSCRIPT, m("sup")],
    [k.SUBSCRIPT, m("sub")],
    [k.HIGHLIGHT, m("mark")],
    [b.TABLE, st],
    [b.TABLE_ROW, rt],
    [b.TABLE_CELL, ut],
    [b.TABLE_HEADER, it]
  ]), z = new Map([...U, ...Object.entries(u).map(([l, F]) => [l, F])]), nt = () => ({
    render: (d, f = {}, E) => {
      if (a && d) {
        const C = t.get(d) || 0;
        t.set(d, C + 1), f.key = `${d}-${C}`;
      }
      return e(d, f, E);
    },
    originalResolvers: U,
    mergedResolvers: z
  });
  function S(l) {
    const F = z.get(l.type);
    if (!F)
      return console.error("<Storyblok>", `No resolver found for node type ${l.type}`), "";
    const d = nt();
    if (l.type === "text") return F(l, d);
    const f = l.content ? l.content.map($) : void 0;
    return F({
      ...l,
      children: f
    }, d);
  }
  function $(l) {
    return l.type === "doc" ? o ? l.content.map(S) : l.content.map(S).join("") : Array.isArray(l) ? l.map(S) : S(l);
  }
  return { render: $ };
}
let W = !1;
const Y = [], tt = (s) => new Promise((t, e) => {
  if (typeof window > "u") {
    e(new Error("Cannot load Storyblok bridge: window is undefined (server-side environment)"));
    return;
  }
  if (window.storyblokRegisterEvent = (u) => {
    if (!window.location.search.includes("_storyblok")) {
      console.warn("You are not in Draft Mode or in the Visual Editor.");
      return;
    }
    W ? u() : Y.push(u);
  }, document.getElementById("storyblok-javascript-bridge")) {
    t(void 0);
    return;
  }
  const r = document.createElement("script");
  r.async = !0, r.src = s, r.id = "storyblok-javascript-bridge", r.onerror = (u) => e(u), r.onload = (u) => {
    Y.forEach((i) => i()), W = !0, t(u);
  }, document.getElementsByTagName("head")[0].appendChild(r);
});
var Rt = Object.defineProperty, St = (s, t, e) => t in s ? Rt(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e, p = (s, t, e) => St(s, typeof t != "symbol" ? t + "" : t, e);
class It extends Error {
  constructor(t) {
    super(t), this.name = "AbortError";
  }
}
function Lt(s, t, e) {
  if (!Number.isFinite(t))
    throw new TypeError("Expected `limit` to be a finite number");
  if (!Number.isFinite(e))
    throw new TypeError("Expected `interval` to be a finite number");
  const r = [];
  let u = [], i = 0, a = !1;
  const o = async () => {
    i++;
    const c = r.shift();
    if (c)
      try {
        const D = await s(...c.args);
        c.resolve(D);
      } catch (D) {
        c.reject(D);
      }
    const h = setTimeout(() => {
      i--, r.length > 0 && o(), u = u.filter((D) => D !== h);
    }, e);
    u.includes(h) || u.push(h);
  }, n = (...c) => a ? Promise.reject(
    new Error(
      "Throttled function is already aborted and not accepting new promises"
    )
  ) : new Promise((h, D) => {
    r.push({
      resolve: h,
      reject: D,
      args: c
    }), i < t && o();
  });
  return n.abort = () => {
    a = !0, u.forEach(clearTimeout), u = [], r.forEach(
      (c) => c.reject(() => new It("Throttle function aborted"))
    ), r.length = 0;
  }, n;
}
const K = (s = "") => s.includes("/cdn/"), Tt = (s, t = 25, e = 1) => ({
  ...s,
  per_page: t,
  page: e
}), Ot = (s) => new Promise((t) => setTimeout(t, s)), Pt = (s = 0, t) => Array.from({ length: s }, t), $t = (s = 0, t = s) => {
  const e = Math.abs(t - s) || 0, r = s < t ? 1 : -1;
  return Pt(e, (u, i) => i * r + s);
}, jt = async (s, t) => Promise.all(s.map(t)), Nt = (s = [], t) => s.map(t).reduce((e, r) => [...e, ...r], []), H = (s, t, e) => {
  const r = [];
  for (const u in s) {
    if (!Object.prototype.hasOwnProperty.call(s, u))
      continue;
    const i = s[u];
    if (i == null)
      continue;
    const a = e ? "" : encodeURIComponent(u);
    let o;
    typeof i == "object" ? o = H(
      i,
      t ? t + encodeURIComponent(`[${a}]`) : a,
      Array.isArray(i)
    ) : o = `${t ? t + encodeURIComponent(`[${a}]`) : a}=${encodeURIComponent(i)}`, r.push(o);
  }
  return r.join("&");
}, Z = (s) => {
  const t = {
    eu: "api.storyblok.com",
    us: "api-us.storyblok.com",
    cn: "app.storyblokchina.cn",
    ap: "api-ap.storyblok.com",
    ca: "api-ca.storyblok.com"
  };
  return t[s] ?? t.eu;
};
class Ht {
  constructor(t) {
    p(this, "baseURL"), p(this, "timeout"), p(this, "headers"), p(this, "responseInterceptor"), p(this, "fetch"), p(this, "ejectInterceptor"), p(this, "url"), p(this, "parameters"), p(this, "fetchOptions"), this.baseURL = t.baseURL, this.headers = t.headers || new Headers(), this.timeout = t != null && t.timeout ? t.timeout * 1e3 : 0, this.responseInterceptor = t.responseInterceptor, this.fetch = (...e) => t.fetch ? t.fetch(...e) : fetch(...e), this.ejectInterceptor = !1, this.url = "", this.parameters = {}, this.fetchOptions = {};
  }
  /**
   *
   * @param url string
   * @param params ISbStoriesParams
   * @returns Promise<ISbResponse | Error>
   */
  get(t, e) {
    return this.url = t, this.parameters = e, this._methodHandler("get");
  }
  post(t, e) {
    return this.url = t, this.parameters = e, this._methodHandler("post");
  }
  put(t, e) {
    return this.url = t, this.parameters = e, this._methodHandler("put");
  }
  delete(t, e) {
    return this.url = t, this.parameters = e ?? {}, this._methodHandler("delete");
  }
  async _responseHandler(t) {
    const e = [], r = {
      data: {},
      headers: {},
      status: 0,
      statusText: ""
    };
    t.status !== 204 && await t.json().then((u) => {
      r.data = u;
    });
    for (const u of t.headers.entries())
      e[u[0]] = u[1];
    return r.headers = { ...e }, r.status = t.status, r.statusText = t.statusText, r;
  }
  async _methodHandler(t) {
    let e = `${this.baseURL}${this.url}`, r = null;
    t === "get" ? e = `${this.baseURL}${this.url}?${H(this.parameters)}` : r = JSON.stringify(this.parameters);
    const u = new URL(e), i = new AbortController(), { signal: a } = i;
    let o;
    this.timeout && (o = setTimeout(() => i.abort(), this.timeout));
    try {
      const n = await this.fetch(`${u}`, {
        method: t,
        headers: this.headers,
        body: r,
        signal: a,
        ...this.fetchOptions
      });
      this.timeout && clearTimeout(o);
      const c = await this._responseHandler(
        n
      );
      return this.responseInterceptor && !this.ejectInterceptor ? this._statusHandler(this.responseInterceptor(c)) : this._statusHandler(c);
    } catch (n) {
      return {
        message: n
      };
    }
  }
  setFetchOptions(t = {}) {
    Object.keys(t).length > 0 && "method" in t && delete t.method, this.fetchOptions = { ...t };
  }
  eject() {
    this.ejectInterceptor = !0;
  }
  /**
   * Normalizes error messages from different response structures
   * @param data The response data that might contain error information
   * @returns A normalized error message string
   */
  _normalizeErrorMessage(t) {
    if (Array.isArray(t))
      return t[0] || "Unknown error";
    if (t && typeof t == "object") {
      if (t.error)
        return t.error;
      for (const e in t) {
        if (Array.isArray(t[e]))
          return `${e}: ${t[e][0]}`;
        if (typeof t[e] == "string")
          return `${e}: ${t[e]}`;
      }
      if (t.slug)
        return t.slug;
    }
    return "Unknown error";
  }
  _statusHandler(t) {
    const e = /20[0-6]/g;
    return new Promise((r, u) => {
      if (e.test(`${t.status}`))
        return r(t);
      const i = {
        message: this._normalizeErrorMessage(t.data),
        status: t.status,
        response: t
      };
      u(i);
    });
  }
}
const X = "SB-Agent", j = {
  defaultAgentName: "SB-JS-CLIENT",
  defaultAgentVersion: "SB-Agent-Version",
  packageVersion: "7.0.0"
}, Mt = {
  PUBLISHED: "published"
};
let T = {};
const B = {};
class Ut {
  /**
   *
   * @param config ISbConfig interface
   * @param pEndpoint string, optional
   */
  constructor(t, e) {
    p(this, "client"), p(this, "maxRetries"), p(this, "retriesDelay"), p(this, "throttle"), p(this, "accessToken"), p(this, "cache"), p(this, "resolveCounter"), p(this, "relations"), p(this, "links"), p(this, "version"), p(this, "richTextResolver"), p(this, "resolveNestedRelations"), p(this, "stringifiedStoriesCache"), p(this, "inlineAssets");
    let r = t.endpoint || e;
    if (!r) {
      const a = t.https === !1 ? "http" : "https";
      t.oauthToken ? r = `${a}://${Z(t.region)}/v1` : r = `${a}://${Z(t.region)}/v2`;
    }
    const u = new Headers();
    u.set("Content-Type", "application/json"), u.set("Accept", "application/json"), t.headers && (t.headers.constructor.name === "Headers" ? t.headers.entries().toArray() : Object.entries(t.headers)).forEach(([a, o]) => {
      u.set(a, o);
    }), u.has(X) || (u.set(X, j.defaultAgentName), u.set(
      j.defaultAgentVersion,
      j.packageVersion
    ));
    let i = 5;
    t.oauthToken && (u.set("Authorization", t.oauthToken), i = 3), t.rateLimit && (i = t.rateLimit), this.maxRetries = t.maxRetries || 10, this.retriesDelay = 300, this.throttle = Lt(
      this.throttledRequest.bind(this),
      i,
      1e3
    ), this.accessToken = t.accessToken || "", this.relations = {}, this.links = {}, this.cache = t.cache || { clear: "manual" }, this.resolveCounter = 0, this.resolveNestedRelations = t.resolveNestedRelations || !0, this.stringifiedStoriesCache = {}, this.version = t.version || Mt.PUBLISHED, this.inlineAssets = t.inlineAssets || !1, this.client = new Ht({
      baseURL: r,
      timeout: t.timeout || 0,
      headers: u,
      responseInterceptor: t.responseInterceptor,
      fetch: t.fetch
    });
  }
  parseParams(t) {
    return t.token || (t.token = this.getToken()), t.cv || (t.cv = B[t.token]), Array.isArray(t.resolve_relations) && (t.resolve_relations = t.resolve_relations.join(",")), typeof t.resolve_relations < "u" && (t.resolve_level = 2), t;
  }
  factoryParamOptions(t, e) {
    return K(t) ? this.parseParams(e) : e;
  }
  makeRequest(t, e, r, u, i) {
    const a = this.factoryParamOptions(
      t,
      Tt(e, r, u)
    );
    return this.cacheResponse(t, a, void 0, i);
  }
  get(t, e = {}, r) {
    e || (e = {});
    const u = `/${t}`;
    K(u) && (e.version = e.version || this.version);
    const i = this.factoryParamOptions(u, e);
    return this.cacheResponse(u, i, void 0, r);
  }
  async getAll(t, e = {}, r, u) {
    const i = (e == null ? void 0 : e.per_page) || 25, a = `/${t}`.replace(/\/$/, ""), o = r ?? a.substring(a.lastIndexOf("/") + 1);
    e.version = e.version || this.version;
    const n = 1, c = await this.makeRequest(
      a,
      e,
      i,
      n,
      u
    ), h = c.total ? Math.ceil(c.total / (c.perPage || i)) : 1, D = await jt(
      $t(n, h),
      (A) => this.makeRequest(a, e, i, A + 1, u)
    );
    return Nt([c, ...D], (A) => Object.values(A.data[o]));
  }
  post(t, e = {}, r) {
    const u = `/${t}`;
    return this.throttle("post", u, e, r);
  }
  put(t, e = {}, r) {
    const u = `/${t}`;
    return this.throttle("put", u, e, r);
  }
  delete(t, e = {}, r) {
    e || (e = {});
    const u = `/${t}`;
    return this.throttle("delete", u, e, r);
  }
  getStories(t = {}, e) {
    return this._addResolveLevel(t), this.get("cdn/stories", t, e);
  }
  getStory(t, e = {}, r) {
    return this._addResolveLevel(e), this.get(`cdn/stories/${t}`, e, r);
  }
  getToken() {
    return this.accessToken;
  }
  ejectInterceptor() {
    this.client.eject();
  }
  _addResolveLevel(t) {
    typeof t.resolve_relations < "u" && (t.resolve_level = 2);
  }
  _cleanCopy(t) {
    return JSON.parse(JSON.stringify(t));
  }
  _insertLinks(t, e, r) {
    const u = t[e];
    u && u.fieldtype === "multilink" && u.linktype === "story" && typeof u.id == "string" && this.links[r][u.id] ? u.story = this._cleanCopy(this.links[r][u.id]) : u && u.linktype === "story" && typeof u.uuid == "string" && this.links[r][u.uuid] && (u.story = this._cleanCopy(this.links[r][u.uuid]));
  }
  /**
   *
   * @param resolveId A counter number as a string
   * @param uuid The uuid of the story
   * @returns string | object
   */
  getStoryReference(t, e) {
    return this.relations[t][e] ? JSON.parse(this.stringifiedStoriesCache[e] || JSON.stringify(this.relations[t][e])) : e;
  }
  /**
   * Resolves a field's value by replacing UUIDs with their corresponding story references
   * @param jtree - The JSON tree object containing the field to resolve
   * @param treeItem - The key of the field to resolve
   * @param resolveId - The unique identifier for the current resolution context
   *
   * This method handles both single string UUIDs and arrays of UUIDs:
   * - For single strings: directly replaces the UUID with the story reference
   * - For arrays: maps through each UUID and replaces with corresponding story references
   */
  _resolveField(t, e, r) {
    const u = t[e];
    typeof u == "string" ? t[e] = this.getStoryReference(r, u) : Array.isArray(u) && (t[e] = u.map(
      (i) => this.getStoryReference(r, i)
    ).filter(Boolean));
  }
  /**
   * Inserts relations into the JSON tree by resolving references
   * @param jtree - The JSON tree object to process
   * @param treeItem - The current field being processed
   * @param fields - The relation patterns to resolve (string or array of strings)
   * @param resolveId - The unique identifier for the current resolution context
   *
   * This method handles two types of relation patterns:
   * 1. Nested relations: matches fields that end with the current field name
   *    Example: If treeItem is "event_type", it matches patterns like "*.event_type"
   *
   * 2. Direct component relations: matches exact component.field patterns
   *    Example: "event.event_type" for component "event" and field "event_type"
   *
   * The method supports both string and array formats for the fields parameter,
   * allowing flexible specification of relation patterns.
   */
  _insertRelations(t, e, r, u) {
    if (Array.isArray(r) ? r.find((a) => a.endsWith(`.${e}`)) : r.endsWith(`.${e}`)) {
      this._resolveField(t, e, u);
      return;
    }
    const i = t.component ? `${t.component}.${e}` : e;
    (Array.isArray(r) ? r.includes(i) : r === i) && this._resolveField(t, e, u);
  }
  /**
   * Recursively traverses and resolves relations in the story content tree
   * @param story - The story object containing the content to process
   * @param fields - The relation patterns to resolve
   * @param resolveId - The unique identifier for the current resolution context
   */
  iterateTree(t, e, r) {
    const u = (i, a = "") => {
      if (!(!i || i._stopResolving)) {
        if (Array.isArray(i))
          i.forEach((o, n) => u(o, `${a}[${n}]`));
        else if (typeof i == "object")
          for (const o in i) {
            const n = a ? `${a}.${o}` : o;
            (i.component && i._uid || i.type === "link") && (this._insertRelations(i, o, e, r), this._insertLinks(i, o, r)), u(i[o], n);
          }
      }
    };
    u(t.content);
  }
  async resolveLinks(t, e, r) {
    let u = [];
    if (t.link_uuids) {
      const i = t.link_uuids.length, a = [], o = 50;
      for (let n = 0; n < i; n += o) {
        const c = Math.min(i, n + o);
        a.push(t.link_uuids.slice(n, c));
      }
      for (let n = 0; n < a.length; n++)
        (await this.getStories({
          per_page: o,
          language: e.language,
          version: e.version,
          starts_with: e.starts_with,
          by_uuids: a[n].join(",")
        })).data.stories.forEach(
          (c) => {
            u.push(c);
          }
        );
    } else
      u = t.links;
    u.forEach((i) => {
      this.links[r][i.uuid] = {
        ...i,
        _stopResolving: !0
      };
    });
  }
  async resolveRelations(t, e, r) {
    let u = [];
    if (t.rel_uuids) {
      const i = t.rel_uuids.length, a = [], o = 50;
      for (let n = 0; n < i; n += o) {
        const c = Math.min(i, n + o);
        a.push(t.rel_uuids.slice(n, c));
      }
      for (let n = 0; n < a.length; n++)
        (await this.getStories({
          per_page: o,
          language: e.language,
          version: e.version,
          starts_with: e.starts_with,
          by_uuids: a[n].join(","),
          excluding_fields: e.excluding_fields
        })).data.stories.forEach((c) => {
          u.push(c);
        });
      u.length > 0 && (t.rels = u, delete t.rel_uuids);
    } else
      u = t.rels;
    u && u.length > 0 && u.forEach((i) => {
      this.relations[r][i.uuid] = {
        ...i,
        _stopResolving: !0
      };
    });
  }
  /**
   *
   * @param responseData
   * @param params
   * @param resolveId
   * @description Resolves the relations and links of the stories
   * @returns Promise<void>
   *
   */
  async resolveStories(t, e, r) {
    var u, i;
    let a = [];
    if (this.links[r] = {}, this.relations[r] = {}, typeof e.resolve_relations < "u" && e.resolve_relations.length > 0 && (typeof e.resolve_relations == "string" && (a = e.resolve_relations.split(",")), await this.resolveRelations(t, e, r)), e.resolve_links && ["1", "story", "url", "link"].includes(e.resolve_links) && ((u = t.links) != null && u.length || (i = t.link_uuids) != null && i.length) && await this.resolveLinks(t, e, r), this.resolveNestedRelations)
      for (const o in this.relations[r])
        this.iterateTree(
          this.relations[r][o],
          a,
          r
        );
    t.story ? this.iterateTree(t.story, a, r) : t.stories.forEach((o) => {
      this.iterateTree(o, a, r);
    }), this.stringifiedStoriesCache = {}, delete this.links[r], delete this.relations[r];
  }
  async cacheResponse(t, e, r, u) {
    const i = H({ url: t, params: e }), a = this.cacheProvider();
    if (e.version === "published" && t !== "/cdn/spaces/me") {
      const o = await a.get(i);
      if (o)
        return Promise.resolve(o);
    }
    return new Promise(async (o, n) => {
      var c;
      try {
        const h = await this.throttle(
          "get",
          t,
          e,
          u
        );
        if (h.status !== 200)
          return n(h);
        let D = { data: h.data, headers: h.headers };
        if ((c = h.headers) != null && c["per-page"] && (D = Object.assign({}, D, {
          perPage: h.headers["per-page"] ? Number.parseInt(h.headers["per-page"]) : 0,
          total: h.headers["per-page"] ? Number.parseInt(h.headers.total) : 0
        })), D.data.story || D.data.stories) {
          const m = this.resolveCounter = ++this.resolveCounter % 1e3;
          await this.resolveStories(D.data, e, `${m}`), D = await this.processInlineAssets(D);
        }
        e.version === "published" && t !== "/cdn/spaces/me" && await a.set(i, D);
        const A = this.cache.clear === "onpreview" && e.version === "draft" || this.cache.clear === "auto";
        return e.token && D.data.cv && (A && B[e.token] && B[e.token] !== D.data.cv && await this.flushCache(), B[e.token] = D.data.cv), o(D);
      } catch (h) {
        if (h.response && h.status === 429 && (r = typeof r > "u" ? 0 : r + 1, r < this.maxRetries))
          return console.log(
            `Hit rate limit. Retrying in ${this.retriesDelay / 1e3} seconds.`
          ), await Ot(this.retriesDelay), this.cacheResponse(t, e, r).then(o).catch(n);
        n(h);
      }
    });
  }
  throttledRequest(t, e, r, u) {
    return this.client.setFetchOptions(u), this.client[t](e, r);
  }
  cacheVersions() {
    return B;
  }
  cacheVersion() {
    return B[this.accessToken];
  }
  setCacheVersion(t) {
    this.accessToken && (B[this.accessToken] = t);
  }
  clearCacheVersion() {
    this.accessToken && (B[this.accessToken] = 0);
  }
  cacheProvider() {
    switch (this.cache.type) {
      case "memory":
        return {
          get(t) {
            return Promise.resolve(T[t]);
          },
          getAll() {
            return Promise.resolve(T);
          },
          set(t, e) {
            return T[t] = e, Promise.resolve(void 0);
          },
          flush() {
            return T = {}, Promise.resolve(void 0);
          }
        };
      case "custom":
        if (this.cache.custom)
          return this.cache.custom;
      // eslint-disable-next-line no-fallthrough
      default:
        return {
          get() {
            return Promise.resolve();
          },
          getAll() {
            return Promise.resolve(void 0);
          },
          set() {
            return Promise.resolve(void 0);
          },
          flush() {
            return Promise.resolve(void 0);
          }
        };
    }
  }
  async flushCache() {
    return await this.cacheProvider().flush(), this.clearCacheVersion(), this;
  }
  async processInlineAssets(t) {
    if (!this.inlineAssets)
      return t;
    const e = (r) => {
      if (!r || typeof r != "object")
        return r;
      if (Array.isArray(r))
        return r.map((i) => e(i));
      let u = { ...r };
      u.fieldtype === "asset" && Array.isArray(t.data.assets) && (u = {
        ...u,
        ...t.data.assets.find((i) => i.id === u.id)
      });
      for (const i in u)
        typeof u[i] == "object" && (u[i] = e(u[i]));
      return u;
    };
    return t.data.story && (t.data.story.content = e(t.data.story.content)), t.data.stories && (t.data.stories = t.data.stories.map((r) => (r.content = e(r.content), r))), t;
  }
}
const zt = (s = {}) => {
  const { apiOptions: t } = s;
  if (!t || !t.accessToken) {
    console.error(
      "You need to provide an access token to interact with Storyblok API. Read https://www.storyblok.com/docs/api/content-delivery#topics/authentication"
    );
    return;
  }
  return { storyblokApi: new Ut(t) };
}, Gt = (s) => {
  if (typeof s != "object" || typeof s._editable > "u")
    return {};
  try {
    const t = JSON.parse(
      s._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, "")
    );
    return t ? {
      "data-blok-c": JSON.stringify(t),
      "data-blok-uid": `${t.id}-${t.uid}`
    } : {};
  } catch {
    return {};
  }
};
let N = "https://app.storyblok.com/f/storyblok-v2-latest.js";
const qt = (s, t, e = {}) => {
  var o;
  const u = !(typeof window > "u") && typeof window.storyblokRegisterEvent < "u", i = new URL((o = window.location) == null ? void 0 : o.href).searchParams.get(
    "_storyblok"
  ), a = i !== null && +i === s;
  if (!(!u || !a)) {
    if (!s) {
      console.warn("Story ID is not defined. Please provide a valid ID.");
      return;
    }
    window.storyblokRegisterEvent(() => {
      new window.StoryblokBridge(e).on(["input", "published", "change"], (c) => {
        var h;
        c && (c.action === "input" && ((h = c.story) == null ? void 0 : h.id) === s ? t(c.story) : (c.action === "change" || c.action === "published") && c.storyId === s && window.location.reload());
      });
    });
  }
}, Jt = (s = {}) => {
  var h, D;
  const {
    bridge: t,
    accessToken: e,
    use: r = [],
    apiOptions: u = {},
    bridgeUrl: i
  } = s;
  u.accessToken = u.accessToken || e;
  const a = { bridge: t, apiOptions: u };
  let o = {};
  r.forEach((A) => {
    o = { ...o, ...A(a) };
  }), i && (N = i);
  const c = !(typeof window > "u") && ((D = (h = window.location) == null ? void 0 : h.search) == null ? void 0 : D.includes("_storyblok_tk"));
  return t !== !1 && c && tt(N), o;
};
function Vt(s, t) {
  return _t(t).render(s);
}
const Wt = () => tt(N);
export {
  b as BlockTypes,
  k as MarkTypes,
  bt as TextTypes,
  zt as apiPlugin,
  Wt as loadStoryblokBridge,
  qt as registerStoryblokBridge,
  Vt as renderRichText,
  _t as richTextResolver,
  Gt as storyblokEditable,
  Jt as storyblokInit,
  qt as useStoryblokBridge
};
